import { gql } from "@apollo/client";

export default gql`
  fragment OrganizationTalentIndicator on TalentIndicatorNode {
    id
    talentIndicatorType
    name
    customName
    questionTitle
    description
    scaleStartsAt
    scale
    labels
    labelDescriptions
    isManagerIndicator
    hasLockedLabels
    hasAssessmentQuestions
  }
`;
